import React from 'react';
import './styles.scss';
import { Column, Row } from '../../../components/layout';
import Header1 from '../../../components/headers/header1';
import * as fonts from '../../../util/fonts';
import colors from '../../../util/colors';
import AppButton from '../../../components/app-button';
import { useHistory } from 'react-router-dom';
import RegisterHeader from '../../../components/headers/register-header';
import { strings } from '../../../util/strings';
import { compose } from 'redux';
import { connect } from 'react-redux';
import {
  setIsLanguageSelected,
  setLanguage,
  setWizard,
} from '../../../store/actions';

interface BlockedRegistrationProps {
  labels: typeof strings.pt.register;
  registoCMDLables: typeof strings.pt.registoCMD;
  messagesLabels: typeof strings.pt.messages;
  languageOptions: any;
  setWizard(values: any): void;
  setIsLanguageSelected(values: any): void;
  setLanguage(values: any): void;
}

function BlockedRegistration({
  labels,
  registoCMDLables,
  messagesLabels,
  languageOptions,
  setWizard,
  setIsLanguageSelected,
  setLanguage,
}: BlockedRegistrationProps) {
  const history = useHistory();

  const handleCMDClick = () => {
    if (registoCMDLables?.registoCMD_cmdRegisterUrl) {
      window.location.href = registoCMDLables.registoCMD_cmdRegisterUrl;
    }
  };

  const handleLoginClick = () => {
    setWizard({});
    setIsLanguageSelected(false);
    setLanguage(
      languageOptions?.find(
        (option: any) =>
          option.indexOf(navigator.language?.split('-' || '_')[0]) > -1,
      ) || messagesLabels?.default_language,
    );
    history.push('/');
  };

  return (
    <Column className="register-main-column">
      <RegisterHeader />
      <Column className="register-container">
        <Row className="register-header-error-row">
          <Header1
            style={{
              ...fonts.XL,
              color: colors.alertRed,
              fontWeight: 'bold',
              textAlign: 'center',
            }}>
            {labels?.register_notclient_error_title}
          </Header1>
        </Row>
        <Row className="register-header-error-row-responsive">
          <Header1
            style={{
              ...fonts.L,
              color: colors.alertRed,
              fontWeight: 'bold',
              textAlign: 'center',
            }}>
            {labels?.register_notclient_error_title}
          </Header1>
        </Row>
        <Column
          className="register-minor-user-text"
          style={{ ...fonts.ML, alignItems: 'center' }}>
          <Row
            className="register-minor-user-text-row"
            style={{ textAlign: 'center', marginBottom: '2rem' }}>
            {labels?.register_notclient_error_description}
          </Row>

          <AppButton
            onClick={handleCMDClick}
            className="register-minor-user-button"
            style={{ width: '250px', marginBottom: '1rem' }}>
            {labels?.register_notclient_button_cmd || 'Registar com CMD'}
          </AppButton>

          <AppButton
            onClick={handleLoginClick}
            className="register-minor-user-button"
            style={{ width: '250px' }}>
            {labels?.register_notclient_button_login || 'Voltar para o login'}
          </AppButton>
        </Column>
      </Column>
    </Column>
  );
}

const mapStateToProps = ({ stringsDefault, languageOptions }: any) => ({
  labels: stringsDefault.value.pt.register,
  registoCMDLables: stringsDefault.value.pt.registoCMD,
  messagesLabels: stringsDefault.value.pt.messages,
  languageOptions: languageOptions.value,
});

const mapDispatchToProps = (dispatch: any) => ({
  setWizard: (value: any) => dispatch(setWizard(value)),
  setIsLanguageSelected: (value: any) => dispatch(setIsLanguageSelected(value)),
  setLanguage: (value: any) => dispatch(setLanguage(value)),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps)(BlockedRegistration),
);
